export const SUPPORTED_HEADING_LEVELS = [1, 2, 3, 4] as const
